import { makeStyles, createStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

/**
 * ContentCenter component styles
 * @returns {Function}
 */

export const useStyles = makeStyles((theme) =>
  createStyles({
    contentCenter: {
      backgroundColor: variables.colorV2.body.background.default,
      display: 'flex',
      height: '100%',
    },

    title: {
      padding: theme.spacing(3),
      borderBottom: `${variables.borderWidth.sm} solid ${variables.color.primary.lightGray}`,
    },

    contentCenterLeft: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      padding: '1.7rem 1.7rem',
      width: '100%',
    },

    upload: {
      margin: theme.spacing(1.25, 0, 0, 3),
    },

    delete: {
      margin: theme.spacing(1.25, 0, 0, 3),
    },

    businessUnit: {
      margin: theme.spacing(0, 0, 2.25),
    },
  }),
);
